import React from "react";
import Hero from "./Hero";
import Header from "./Header";
import Footer from "./Footer";
import GetStarted from "./GetStarted";

// The contact page shows the same contact section as the home page.
const Kontakt = () => (
  <div className="KeysHome">
    <Header />
    <main className="main">
      <Hero compact />
      <GetStarted />
    </main>
    <Footer />
  </div>
);

export default Kontakt;
